// Copyright 2020 Sorama B.V.

import { bindable, computedFrom, customElement } from "aurelia-framework";
import { IGuidanceTopic } from "catalogs/GuidanceCatalog";
import { IWorkflowModuleCatalog } from "catalogs/IWorkflowModuleCatalog";
import { WorkflowModuleType } from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";
import { ShellViewManager } from "modules/shell/App/ShellViewManager";
import { WorkflowModeService } from "services/WorkflowModes/WorkflowModeService";

@customElement("guidance-link")
export class GuidanceLink {
    @bindable
    public collapsed = true;

    @bindable
    private articleName: string;

    @computedFrom("module", "workflowModeService.selectedWorkflowMode")
    protected get isShown() {
        if (!this.module.relevantWorkflowModes) return true;

        return this.module.relevantWorkflowModes.includes(this.workflowModeService.selectedWorkflowMode);
    }

    private module: IGuidanceTopic;

    private isDescription = true;

    constructor(
        private readonly catalog: IWorkflowModuleCatalog,
        private readonly shellviewManager: ShellViewManager,
        private readonly workflowModeService: WorkflowModeService
    ) {}

    public bind(): void {
        this.findArticle();
    }

    private findArticle(): void {
        this.module = <IGuidanceTopic>(
            this.catalog.getWorkflowModules(WorkflowModuleType.Help).find((x) => x.name == this.articleName)
        );
    }

    private openCurrentArticle(): void {
        if (this.articleName) {
            this.shellviewManager.openRightSideBarHelp(this.articleName);
        }
    }
}
